import { useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { TimePeriod } from "pages/client-reporting/const";
import {
  clientReportingSelectors,
  clientReportingSliceActions,
} from "store/reducers/client-reporting/reducer";
import { MAIN_TABS } from "store/reducers/tabs";

export const useReadMoreHandler = (contractId: number | null) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { contracts, minDate, maxDate } = useAppSelector(
    clientReportingSelectors.selectClientReportingState
  );

  const handleReadMoreButtonClick = () => {
    // Устанавливаем ID
    dispatch(
      clientReportingSliceActions.setInvestmentId({
        investmentId: String(contractId),
      })
    );
    // Устанавливаем пункт меню
    dispatch(
      clientReportingSliceActions.setPeriod({ period: TimePeriod.AllTime })
    );
    // устанавливаем даты с - по
    const contractById = contracts.find(
      (contract) => contract.contractID === contractId
    );
    dispatch(
      clientReportingSliceActions.setDate({
        dateFrom: contractById
          ? new Date(contractById.durationDateFrom)
          : minDate,
        dateTo: contractById ? new Date(contractById.durationDateTo) : maxDate,
      })
    );
    navigate(`/${MAIN_TABS.REPORTING_PERIOD}`);
  };

  return {
    handleReadMoreButtonClick,
  };
};
